const DefinedFunction = {
    'round': {
        op: 'round',
        priority: 0,
        opNum: 1,
        type: 'function',
        calc: (op) => {
            return op.round();
        }
    },
    'power': {
        op: 'power',
        priority: 0,
        opNum: 2,
        type: 'function',
        calc: (op1, op2) => {
            return op1.pow(op2);
        }
    },
    'abs': {
        op: 'abs',
        priority: 0,
        opNum: 1,
        type: 'function',
        calc: (op) => {
            return op.abs();
        }
    },
    'sqrt': {
        op: 'sqrt',
        priority: 0,
        opNum: 1,
        type: 'function',
        calc: (op) => {
            return op.sqrt();
        }
    },
    'sum': {
        op: 'sum',
        priority: 0,
        opNum: 1,
        type: 'function',
        calc: (op) => {
            if (op  instanceof Array) {
                return op.reduce(function(prev, curr) {
                    return prev + curr;
                })
            } else {
                return op;
            }
        }
    }
}

export default DefinedFunction 